module.exports = __webpack_public_path__ + "img/brmusiclogo.01f775b1.png";